import _ from 'lodash';
import { connect } from 'react-redux';
import {
	get, update, add, send, publicGet,
	getEmailInfo, invalidate, getProductInvoiceMatrix
} from '../../modules/accounting/stationInvoice';
import { showErrors } from '../../modules/general';
import { bindActionCreators } from 'redux';

const mapStateToProps = (state, ownProps) => {
	let stationInvoice;
	let stationInvoiceId;

	if (ownProps.stationInvoice) {
		stationInvoice = ownProps.stationInvoice;
	} else {
		stationInvoiceId = (ownProps.stationInvoiceId)
			? ownProps.stationInvoiceId
			: _.get(ownProps, ['match', 'params', 'stationInvoiceId']);
		stationInvoice = _.get(state.maps, ['stationInvoice', stationInvoiceId]);
	}

	/** @namespace state.maps.stationDelivery **/
	/** @namespace state.maps.stationQuotedPrice */
	return {
		stationInvoice,
		stationMap : state.maps.station,
		userMap : state.maps.user,
		resourceMap : state.maps.resource,
		carrierMap : state.maps.carrier,
		terminalMap : state.maps.terminal,
		supplierMap : state.maps.supplier,
		gasFormulaMap : state.maps.gasFormula,
		rackFormulaMap : state.maps.rackFormula,
		biodieselFormulaMap : state.maps.biodieselFormula,
		stationDeliveryMap : state.maps.stationDelivery,
		invoiceDocumentMap : state.maps.invoiceDocument,
		quickbooksCustomerMap : state.maps.quickbooksCustomer,
		quickbooksTermMap : state.maps.quickbooksTerm,
		stationQuotedPriceMap : state.maps.stationQuotedPrice,
		dataDumpMap : state.maps.dataDump,
	};
};

const mapDispatchToProps = dispatch => bindActionCreators({
	getStationInvoice : get,
	addStationInvoice : add,
	updateStationInvoice : update,
	sendStationInvoice : send,
	publicGetStationInvoice : publicGet,
	getStationInvoiceEmailInfo : getEmailInfo,
	invalidateStationInvoice : invalidate,
	getProductInvoiceMatrix,
	showErrors,
}, dispatch);

export default connect(
	mapStateToProps,
	mapDispatchToProps
);
